import React, { useState, useEffect } from "react";
import "./logoPage.css";
import android from "../picture/Android.png";
import apple from "../picture/Apple.png";
import logo from "../picture/Logo.png";
import youtube from "../picture/Youtube.png";
import rectangularPlay from "../picture/rectangular-play.png";
import www from "../picture/Www.png";
import { useGlobalContext } from "../Context/Context";
import useIsOpening from "../Context/hooks/useIsOpening";
import useIsDemo from "../Context/hooks/useIsDemo";
import axios from "axios";

const LogoPage = ({ setCurrentPage }) => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstallVisible, setIsInstallVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const {
    isAndroid,
    setIsAndroid,
    isIOS,
    setIsIOS,
    isFromHome,
    setLoggedUser,
  } = useGlobalContext();

  const { isOpening } = useIsOpening();
  const { isDemo, demoEmail } = useIsDemo();
  const { baseUrl, setApiKey } = useGlobalContext();

  const searchParams = new URLSearchParams(window.location.search);
  const DEMO_EMAIL = isDemo
    ? demoEmail
    : searchParams.get("email") || "demouser1@gmail.com";
  const DEMO_PASSWORD = "demo12";

  const handleDemoLogin = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.post(`${baseUrl}/auth/login.php`, {
        user_email: DEMO_EMAIL,
        user_pin: DEMO_PASSWORD,
      });

      if (data.status === 200) {
        const demoUser = {
          id: parseInt(data.user_id),
          user_email: DEMO_EMAIL,
          name: data.name,
          pattern: data.pattern ?? "",
          isPatternSet: true,
          defaultHomePage: data.defaultHomePage,
          typeButton: data.typeButton,
          colorButton: data.colorButton,
          letterSize:
            data.letterSize === null ? undefined : parseInt(data.letterSize),
          boldItalic: data.boldItalic ?? [],
          fontSize: data.fontSize,
          fontStyle: data.fontStyle,
          profileId: data.profile_id,
          isAdmin: data.isAdmin,
          isTemp: false,
          privilage: "",
          firstContact: "",
          secondContact: "",
          user_pin: null,
        };

        setLoggedUser(demoUser);
        setApiKey(data.api_key);
        localStorage.setItem("editor-user", JSON.stringify(demoUser));
        localStorage.setItem("api-key", JSON.stringify(data.api_key));
        setCurrentPage(4);
      }
    } catch (error) {
      console.log("Demo login error:", error);
      setCurrentPage(3);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSetCurrentPage = () => {
    if (isDemo || isOpening) {
      handleDemoLogin();
    } else if (isFromHome) {
      setCurrentPage(4);
      setLoggedUser(JSON.parse(localStorage.getItem("editor-user")));
    } else {
      setCurrentPage(3);
    }
  };

  useEffect(() => {
    const interval = setTimeout(() => {
      handleSetCurrentPage();
    }, 4000);

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsInstallVisible(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone;

    if (!isStandalone) {
      const userAgent = window.navigator.userAgent.toLowerCase();
      if (/android/.test(userAgent)) {
        setIsAndroid(true);
        setIsIOS(false);
      } else if (/iphone|ipad|ipod/.test(userAgent)) {
        setIsIOS(true);
        setIsAndroid(false);
      }
    } else {
      setIsInstallVisible(false);
    }

    return () => {
      clearTimeout(interval);
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt,
      );
    };
  }, [setCurrentPage]);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const choiceResult = await deferredPrompt.userChoice;
    if (choiceResult.outcome === "accepted") {
      console.log("User accepted the install prompt");
    } else {
      console.log("User dismissed the install prompt");
    }
    setDeferredPrompt(null);
    setIsInstallVisible(false);
  };

  if (isLoading) {
    return (
      <div
        className="wrapper-logo"
        style={{ justifyContent: "center", alignItems: "center" }}
      >
        <div className="demo-spinner" />
      </div>
    );
  }

  return (
    <>
      <div
        className="wrapper-logo"
        style={
          !isInstallVisible
            ? { justifyContent: "flex-end", paddingBottom: "10%" }
            : { justifyContent: "center" }
        }
      >
        {isInstallVisible && (
          <div className="android-apple">
            <img
              src={apple}
              alt="Install on iOS"
              onClick={isIOS ? handleInstallClick : null}
              className={isIOS ? "glow" : ""}
            />
            <img
              src={android}
              alt="Install on Android"
              onClick={isAndroid ? handleInstallClick : null}
              className={isAndroid ? "glow" : ""}
            />
          </div>
        )}
        <div
          className="logo"
          onClick={() => setCurrentPage(3)}
          onTouchStart={() => setCurrentPage(3)}
        >
          <img src={logo} alt="Logo" style={{ marginBottom: "5vh" }} />
        </div>
        <div className="youtube-link">
          <img src={rectangularPlay} alt="Rectangle Youtube" />
          <img src={www} alt="Website" />
          <img src={youtube} alt="Youtube" />
        </div>
      </div>

      <div className="wrapper-logo-mobile">
        <div
          className="logo"
          onClick={() => setCurrentPage(3)}
          onTouchStart={() => setCurrentPage(3)}
        >
          <img src={logo} alt="Logo" />
        </div>
        <div className="wrapper-logo-mobile-left">
          {isInstallVisible && (
            <div className="android-apple">
              <img
                src={apple}
                alt="Install on iOS"
                onClick={isIOS ? handleInstallClick : null}
                className={isIOS ? "glow" : ""}
              />
              <img
                src={android}
                alt="Install on Android"
                onClick={isAndroid ? handleInstallClick : null}
                className={isAndroid ? "glow" : ""}
              />
            </div>
          )}
          <div className="youtube-link">
            <img src={rectangularPlay} alt="Rectangle YT" />
            <img src={www} alt="Website" />
            <img src={youtube} alt="Youtube" />
          </div>
        </div>
      </div>
    </>
  );
};

export default LogoPage;
